//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  getPaymentPaypartsList,
} from '@api/order.service'

export default {
  name: 'RozetkaPayparts',
  props: {
    price: {
      type: [String, Number],
      required: true,
    },
    id: {
      type: [String, Number],
    },
    type: {
      type: String,
    },
    amount: {
      type: [String, Number],
    },
    shop: {
      type: [String, Number],
      default: '',
    },
  },
  data() {
    return {
      providers: [],
    }
  },
  async mounted() {
    const { data } = await getPaymentPaypartsList.execute({ shop_id: this.shop })
    this.providers = data.filter(provider => provider.props.min_amount <= this.price)
  },
  methods: {
    getValue(props) {
      const maxPeriod = props.available_periods[props.available_periods.length - 1]
      return this.price / Number(maxPeriod)
    },
    test() {
      console.log(this.providers)
    },
    openModal() {
      this.$modal.show(
        () => import('@app/Purchase/PaypartsView'),
        {
          providers: this.providers,
          price: this.price,
          id: this.id,
          type: this.type,
          amount: this.amount,
          shop: this.shop,
        }, {
          height: 'auto',
          adaptive: true,
          scrollable: true,
          classes: ['cart-modal'],
        }
      )
    },
  },
}
